import { useTranslation } from "react-i18next";
import "../assets/css/footer.css";
import logo from "../assets/img/logo.png";
import url from "../assets/data/url.json";
import contact from "../assets/data/contact.json";

const Footer = () => {
    const { t } = useTranslation();
    const socialLinks = Object.entries(url);
    const contactItems = Object.entries(contact);

    return (
        <footer className="footer">
            <section
                className="footer-social"
                aria-label={t("footer.socialLabel", {
                    defaultValue: "Réseaux sociaux",
                })}
            >
                <div className="footer-brand">
                    <img
                        src={logo}
                        alt="JW Studio"
                        className="footer-brand-logo"
                    />
                </div>
                <nav
                    className="footer-social-nav"
                    aria-label="Réseaux sociaux"
                >
                    <ul className="footer-social-list">
                        {socialLinks.map(([key, { url: href, icon }]) => (
                            <li key={key} className="footer-social-item">
                                <a
                                    className="footer-social-link"
                                    href={href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={key}
                                >
                                    <i className={icon} aria-hidden="true"></i>
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>
            </section>

            <section
                className="footer-content"
                aria-label="Informations de contact"
            >
                <div className="footer-grid">
                    <article className="footer-panel footer-panel--intro">
                        <h4 className="footer-title">
                            {t("footer.introTitle")}
                        </h4>
                        <div className="footer-separator" />
                        <p className="footer-text">{t("footer.introText")}</p>
                    </article>

                    <address className="footer-panel footer-panel--contact">
                        <h4 className="footer-title">
                            {t("footer.contactTitle")}
                        </h4>
                        <div className="footer-separator" />
                        <ul className="footer-list">
                            {contactItems.map(
                                ([key, { value, icon, link }]) => (
                                    <li key={key} className="footer-list-item">
                                        <a
                                            className="footer-contact-link"
                                            href={link}
                                        >
                                            <i
                                                className={icon}
                                                aria-hidden="true"
                                            ></i>
                                            <span>{value}</span>
                                        </a>
                                    </li>
                                ),
                            )}
                        </ul>
                    </address>
                </div>
            </section>

            <section
                className="footer-bottom"
                aria-label={t("footer.bottomLabel", {
                    defaultValue: "Informations légales",
                })}
            >
                <span className="footer-bottom-item">JW-STUDIO © 2026</span>
                <a
                    className="footer-bottom-link"
                    href="https://jw-studio.fr/mentions-legales"
                >
                    {t("footer.legal")}
                </a>
                <small className="footer-bottom-item footer-bottom-item--tagline">
                    {t("footer.tagline")}
                </small>
            </section>
        </footer>
    );
};

export default Footer;
